import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Link } from '@mui/material';
import PaywallJoinThousands from '../../javascript/images/PaywallJoinThousandsCompressed.png'
import JoinThousandsText from '../../javascript/images/JoinThousandsText.png'
import MarketProLogo from '../../javascript/images/MarketProLogo.png'
import "../../stylesheets/chat_page.css"
import { useState, useEffect } from 'react';
import PaywallButton from './Mui/PaywallButton';
import { useNavigate } from 'react-router-dom';
import { isMobileBrowser } from '../utils/user_agent';
import { useChatContext } from '../contexts/ChatContext';

const PaywallModal = ({ appProps, userData, setUserData, setShowPaywallModal, paywallMessage, setShowSignUpModal, setShowPaywallAfter, isSidebarOpen, sidebarOffset }) => {

  const navigate = useNavigate();
  const { resetChatState } = useChatContext();

  const [opacity, setOpacity] = useState(0)
  const [subscriberDialogOpen, setSubscriberDialogOpen] = useState(false)

  const handleClose = () => {
    setShowPaywallModal(false); // Hide modal
    // setShowPaywallAfter(false); // won't default to showing after sign up modal close.
  };

  const isMobile = isMobileBrowser()

  useEffect(() => {
    setOpacity(1.0)
  }, [])

  const onClickAction = () => {
    if (userData.user_id) { // if we have the user id...
      navigate('/plan-selection')
    } else {
      setShowPaywallModal(false)
      setShowSignUpModal(true)
    }
  }

  const loginEmail = userData?.user_account_info?.email
  const loginMethod = userData?.user_account_info?.login_method

  return (
    <div className="modal modal-paywall" style={{
      opacity: opacity,
      transition: 'opacity 1.0s',
      }}>
      <div className="paywall-modal-content" style={{
        marginLeft: (!isMobile) ? `${sidebarOffset/2}px` :'unset',
        background: 'linear-gradient(180deg, #DBE1F5 0%, #FFFFFF 100%)',
      }}>
        
        <Box className="base-text" sx={{
          fontSize: '15px', color: '#2971D7', fontWeight: '500', 
          position: 'absolute', top: '20px', left: '20px', '&:hover': {cursor: 'pointer'}}} onClick={handleClose}
        >
          Close
        </Box>

        <Box className="base-text" sx={{gap: '0px', marginBottom: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontWeight: '500', fontSize: '36px'}}>
          <img src={MarketProLogo} style={{width: '32px'}} className="logo-img" alt="IncitePlus Logo" />
          <Box className="header-paywall-modal" sx={{fontWeight: '600', color: '#1D1D1F'}}>
            Incite AI
          </Box>
        </Box>

        <Box className="base-text" sx={{margin: '0px auto 0px auto', fontWeight: '500', fontSize: '17px', lineHeight: '150%',}}>
          Live Market Intelligence
        </Box>
        <Box className="base-text" sx={{margin: '20px auto 26px auto', fontWeight: '500', fontSize: '16px', maxWidth: '85%', lineHeight: '150%', color: '#FD0707'}}>
          {paywallMessage}
        </Box>

        <Box sx={{width: '260px', margin: '0px auto', maxWidth: '86%', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <PaywallButton
            onClick={() => onClickAction()}
            sx={{
              backgroundColor: '#3974CC',
              '&:hover': { backgroundColor: '#3974CC' },
            }}
          >
            <Box sx={{width: '100%', ontWeight: '500', fontSize: '14px', margin: '6px auto',}}>{'Learn More & Upgrade'}</Box>
          </PaywallButton>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '12px' }}>
          <Button
            variant="text"
            size="small"
            onClick={() => setSubscriberDialogOpen(true)}
            sx={{
              textTransform: 'none',
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '150%',
              p: 0,
              minWidth: 0,
            }}
          >
            Already a Subscriber?
          </Button>
        </Box>

        {/* <Box sx={{margin: '26px auto 0px auto', width: '270px'}}>
          <img src={JoinThousandsText} style={{maxWidth: '100%'}}/>
        </Box> */}

        <Box sx={{marginTop: '22px', width: '100%'}}>
          <img src={PaywallJoinThousands} style={{maxWidth: '100%'}}/>
        </Box>
      

        {/* <Box className="base-text" sx={{marginTop: '18px', fontWeight: '500', fontSize: '22px', lineHeight: '133%'}}>
          A world of world-class<br/>intelligence.
        </Box> */}

        <Dialog
          open={subscriberDialogOpen}
          onClose={() => setSubscriberDialogOpen(false)}
          aria-labelledby="subscriber-help-title"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="subscriber-help-title" sx={{ fontWeight: 600 }}>
            Already a Subscriber
          </DialogTitle>
          <DialogContent dividers>
            <Box className="base-text" sx={{ fontSize: '14px', lineHeight: '160%' }}>
              This account is under <b>{loginEmail}</b> using the <b>{loginMethod}</b> login method.
              <br /><br />
              The account you are currently logged into is not linked to an active subscription.
              <br /><br />
              Please try logging back in with the correct email and login method (review the subscription confirmation email you recieved), or contact
              Incite Support at{' '}
              <Link href="mailto:help@inciteai.com" underline="hover">
                help@inciteai.com
              </Link>{' '}
              for further assistance.
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSubscriberDialogOpen(false)}>Close</Button>
            <Button
              onClick={() => {
                fetch("/logout", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                }).then(() => {
                  setShowPaywallModal(false)
                  setSubscriberDialogOpen(false)
                  appProps.clearStateData();
                  resetChatState();
                  navigate("/register");
                })
              }}
              variant="contained"
            >
              Log Out
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    </div>
  )
}

export default PaywallModal
